export default "__VITE_ASSET__DgKLkbYS__"